
import styled from 'styled-components'

export  const DivButton = styled.div `
   width:360px;
   height:67px;
   background-color:#379C44;
   border-radius:20px;
   color:white;
   display:flex;
   justify-content:center;
   padding:5px;
   button{
    background:none;
    border:none;
    color:white;
    font-size:16px;
    font-weight:600;    
    border-radius:20px; 
    width:170px;     
    font-family:"Roboto",sans-serif;     
   }
   button:hover{
    cursor:pointer;
   }
   .active{
    background-color:white;
    color:black;
   }
`
